import { LOADED_PDF_OBJECT_URL } from '../actions/types';

export default function pdfContent(state = {}, { type, payload }) {
  switch (type) {
    case LOADED_PDF_OBJECT_URL:
      return {
        ...state,
        pdfObjectUrl: payload,
      };
    default:
      return state;
  }
}
